function cov_zw7tn39gn() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SelectiveSpritesheet.tsx";
  var hash = "66568fe6bb99f1c867cb09b7696a79e88f8d33cc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SelectiveSpritesheet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 32,
          column: 4
        }
      },
      "1": {
        start: {
          line: 28,
          column: 10
        },
        end: {
          line: 28,
          column: 78
        }
      }
    },
    fnMap: {
      "0": {
        name: "SelectiveSpritesheet",
        decl: {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 18,
            column: 44
          }
        },
        loc: {
          start: {
            line: 23,
            column: 3
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 25
          },
          end: {
            line: 27,
            column: 26
          }
        },
        loc: {
          start: {
            line: 28,
            column: 10
          },
          end: {
            line: 28,
            column: 78
          }
        },
        line: 28
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "66568fe6bb99f1c867cb09b7696a79e88f8d33cc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_zw7tn39gn = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_zw7tn39gn();
import React from 'react';
import { bricks } from "../../system/bricks.types.mjs";
/**
 * Spritesheet component that allows for selective imports of different
 * Spritesheet icons.
 *
 * This can be used with any of the ./Icon/* imports.
 * Most often used in bundle sensitive applications (example: Cosmos)
 *
 * Usage:
 * import ChevronDown16 from '@opendoor/bricks/core/Icon/SpriteSheetIcons/ChevronDown16'
 *
 * <SelectiveSpritesheet icons={[ChevronDown16]}>
 */
export default function SelectiveSpritesheet(props) {
  cov_zw7tn39gn().f[0]++;
  cov_zw7tn39gn().s[0]++;
  return /*#__PURE__*/React.createElement(bricks.svg, {
    opacity: 0,
    width: 0,
    height: 0,
    display: "block",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("defs", null, props.icons.map(_ref => {
    let {
      name,
      svg
    } = _ref;
    cov_zw7tn39gn().f[1]++;
    cov_zw7tn39gn().s[1]++;
    return /*#__PURE__*/React.createElement("g", {
      key: name,
      id: name,
      dangerouslySetInnerHTML: {
        __html: svg
      }
    });
  })));
}